export class AuthConfig {
    checkUser: string;
    register: string;
    newCustomer: string;
    newCustomerVirtual: string;
    login: string;
    logout: string;
    refresh: string;
    current: string;
    //checkPhone: string;
    sendPin: string;
    refreshTokenUrl?: string;
    checkPhoneAndSendPin: string;
    findByAccountId: string;
    registerTerminal: string;
}
